import { useRef, useState } from 'react';
import { useParams } from 'react-router';

import { useApp } from 'src/context/app';
import { AgreementFormEnum } from 'src/graphql/schema';
import { createRequiredContext } from 'src/context/createRequiredContext';

import { type IAgreementFormSettingsValues } from '../ui';

const [useSoftwareEscrowNewContext, SoftwareEscrowNewContext] = createRequiredContext<{
  appId: string;
  formRef: React.RefObject<{
    submit: (callback: (data: IAgreementFormSettingsValues) => void) => void;
  } | null>;
  onSubmit: (callback: (data: IAgreementFormSettingsValues) => void) => void;
  isValid: boolean;
  setIsValid: (isValid: boolean) => void;
}>();

const SoftwareEscrowNewContextProvider = ({ children }: { children: React.ReactNode }) => {
  const { appId = '' } = useParams<{ appId: string }>();
  const { app } = useApp();
  const [isValid, setIsValid] = useState(false);
  const formRef = useRef<{
    submit: (callback: (data: IAgreementFormSettingsValues) => void) => void;
  }>(null);

  const onSubmit = (callback: (data: IAgreementFormSettingsValues) => void) => {
    // Non-owners are the beneficiary, who can only create a tripartite escrow
    if (!app.owned) return callback({ agreementForm: AgreementFormEnum.Tripartite });
    if (formRef.current) formRef.current.submit(callback);
  };

  const value = { appId, formRef, onSubmit, isValid: !app.owned || isValid, setIsValid };

  return <SoftwareEscrowNewContext value={value}>{children}</SoftwareEscrowNewContext>;
};

export { useSoftwareEscrowNewContext, SoftwareEscrowNewContextProvider };
